import Button from "@/components/Button";
import Dialog from "@/components/Dialog";

export type ProfilePhotoPreviewDialogProps = {
  open: boolean;
  photoUrl: string;
  personName: string;
  onClose: () => void;
  onUpdatePhoto?: () => void;
};

export default function ProfilePhotoPreviewDialog({
  open,
  photoUrl,
  personName,
  onClose,
  onUpdatePhoto
}: ProfilePhotoPreviewDialogProps) {
  const handleUpdatePhoto = () => {
    onClose();
    onUpdatePhoto?.();
  };

  return (
    <Dialog
      open={open}
      onClosed={onClose}
      headline="Profile photo"
      displayOverflow
      actions={
        <div className="flex w-full flex-wrap justify-end gap-2">
          {onUpdatePhoto ? (
            <Button variant="filled" icon="photo_camera" onClick={handleUpdatePhoto} testId="profile-photo-update">
              Update photo
            </Button>
          ) : null}
          <Button variant="text" onClick={onClose} testId="profile-photo-preview-close">
            Close
          </Button>
        </div>
      }
    >
      <div className="flex justify-center">
        <img
          src={photoUrl}
          alt={`Profile photo for ${personName}`}
          className="max-h-[min(calc(100dvh-20rem),480px)] w-full max-w-full object-contain"
          data-testid="profile-photo-preview-image"
        />
      </div>
    </Dialog>
  );
}
